<template>
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#4F4F51" />
    <path
      d="M26.3706 23.514C26.3706 24.5411 25.5382 25.3735 24.5111 25.3735H15.4848C14.4577 25.3735 13.6253 24.5411 13.6253 23.514V18.5157C13.6253 17.4887 14.4577 16.6562 15.4848 16.6562H22.8313C23.0885 16.6562 23.2969 16.4478 23.2969 16.1906V13.5907C23.2969 13.3334 23.0885 13.125 22.8313 13.125H14.3338C11.595 13.125 9.375 15.345 9.375 18.0839V23.9615C9.375 26.7004 11.595 28.9204 14.3338 28.9204H25.6615C28.4003 28.9204 30.6203 26.7004 30.6203 23.9615V19.8395C30.6203 19.5822 30.4119 19.3738 30.1546 19.3738H26.8363C26.579 19.3738 26.3706 19.5822 26.3706 19.8395V23.5153V23.514Z"
      fill="white"
    />
    <path
      d="M30.1595 17.2633H25.9774C25.7201 17.2633 25.5117 17.0549 25.5117 16.7976V13.6219C25.5117 13.3647 25.7201 13.1562 25.9774 13.1562H30.1595C30.4167 13.1562 30.6251 13.3647 30.6251 13.6219V16.7976C30.6251 17.0549 30.4167 17.2633 30.1595 17.2633Z"
      fill="#50AF30"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style>
</style>